module.exports = __webpack_public_path__ + "img/13-2.3fa40852.jpg";